import { DAYS } from "../constants/config.js";

export const APP_TIME_ZONE = "Africa/Johannesburg";

export function localDateKey(date = new Date(), timeZone = APP_TIME_ZONE) {
  const parts = new Intl.DateTimeFormat("en-CA", {
    timeZone,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  }).formatToParts(date);
  const get = type => parts.find(part => part.type === type)?.value;
  return `${get("year")}-${get("month")}-${get("day")}`;
}

export function getTodayDay()  {
  const weekday = new Intl.DateTimeFormat("en-US", { timeZone: APP_TIME_ZONE, weekday: "long" }).format(new Date());
  return DAYS.includes(weekday) ? weekday : DAYS[0];
}
export function getTodayDate() { return localDateKey(); }
export function fmtDate(d)     { return new Date(d + "T12:00:00").toLocaleDateString("en-US", { month:"short", day:"numeric" }); }
export function fmtDay(d)      { return new Date(d + "T12:00:00").toLocaleDateString("en-US", { weekday:"short" }); }
export function fmtDateZA()    { return new Date().toLocaleDateString("en-ZA", { month:"long", day:"numeric", year:"numeric" }); }

/** Returns ISO week string e.g. "2026-W10" for a given date string */
export function getISOWeek(dateStr) {
  const date = new Date(dateStr + "T12:00:00");
  const d = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));
  d.setUTCDate(d.getUTCDate() + 4 - (d.getUTCDay() || 7));
  const yearStart = new Date(Date.UTC(d.getUTCFullYear(), 0, 1));
  const weekNum = Math.ceil((((d - yearStart) / 86400000) + 1) / 7);
  return `${d.getUTCFullYear()}-W${String(weekNum).padStart(2, "0")}`;
}

/** Returns array of up to 4 week objects for a given year/month (0-indexed).
 *  Only includes weeks whose Monday falls within the month. */
export function getWeeksInMonth(year, month) {
  const y = month > 11 ? year + 1 : year;
  const m = month > 11 ? 0 : month;
  const weeks = [];
  const daysInMonth = new Date(y, m + 1, 0).getDate();
  // Walk every Monday in the month
  for (let day = 1; day <= daysInMonth && weeks.length < 4; day++) {
    const date = new Date(y, m, day);
    if (date.getDay() !== 1) continue; // only Mondays
    const dateStr = `${y}-${String(m + 1).padStart(2, "0")}-${String(day).padStart(2, "0")}`;
    const weekKey = getISOWeek(dateStr);
    weeks.push({
      key:    weekKey,
      label:  date.toLocaleDateString("en-ZA", { month: "short", day: "numeric" }),
      monday: dateStr,
    });
  }
  return weeks;
}
